import React from 'react';

interface RemoveButtonProps {
  onClick: () => void;
}

export const RemoveButton: React.FC<RemoveButtonProps> = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-8 w-8 sm:h-9 sm:w-9 items-center justify-center rounded-md border border-gray-600 bg-black transition-colors hover:bg-gray-800 hover:border-red-500 flex-shrink-0"
    >
      <svg className="h-3 w-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
      </svg>
    </button>
  );
};

export default RemoveButton;
